export const BiIndicators = [
  {
    title: 'Б11',
    dataFieldName: 'b11',
    about: 'Средний балл ЕГЭ',
    count: '64.8',
    max: 23,
    idUsl: 1,
  },
  {
    title: 'Б12',
    dataFieldName: 'b12',
    about: 'Исполнение КЦП прошлых лет',
    count: '19.4',
    max: 3,
    idUsl: 1,
  },
  {
    title: 'Б13',
    dataFieldName: 'b13',
    about: 'Доля целевого приема',
    count: '3.0',
    max: 4,
    idUsl: 1,
  },
  {
    title: 'Б21',
    dataFieldName: 'b21',
    about: 'Наличие ПОА',
    count: '1.8',
    max: 2,
    idUsl: 1,
  },
  {
    title: 'Б22',
    dataFieldName: 'b22',
    about: 'Соотношение (Маг+Асп)/БС',
    count: '9.0',
    max: 9,
    idUsl: 1,
  },
  {
    title: 'Б23',
    dataFieldName: 'b23',
    about: 'Соотношение (Маг+Асп+Орд)/БС',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 1,
  },
  {
    title: 'Б24',
    dataFieldName: 'b24',
    about: 'Соотношение (Маг+Асп+Аcc)/БС',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 1,
  },
  {
    title: 'Б25',
    dataFieldName: 'b25',
    about: 'Процент сетевых образовательных программ',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 1,
  },
  {
    title: 'Б26',
    dataFieldName: 'b26',
    about: 'Процент сетевых обучающихся',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 1,
  },
  {
    title: 'Б31',
    dataFieldName: 'b31',
    about: 'Трудоустройство выпускников',
    count: '18.7',
    max: 25,
    idUsl: 1,
  },
  {
    title: 'Б32',
    dataFieldName: 'b32',
    about: 'Сохранность контингента',
    count: '4.7',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б33',
    dataFieldName: 'b33',
    about: 'Доходы выпускников',
    count: '4.7',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б41',
    dataFieldName: 'b41',
    about: 'Публикации на 100 НПР',
    count: '0.4',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б42',
    dataFieldName: 'b42',
    about: 'Доходы от НИОКР на 1 НПР',
    count: '1.3',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б43',
    dataFieldName: 'b43',
    about: 'Доля иностранных студентов',
    count: '2.4',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б44',
    dataFieldName: 'b44',
    about: 'Доходы на 1 студента',
    count: '0.9',
    max: 5,
    idUsl: 1,
  },
  {
    title: 'Б11',
    dataFieldName: 'b11',
    about: 'Средний балл ЕГЭ',
    count: '64.8',
    max: 23,
    idUsl: 2,
  },
  {
    title: 'Б12',
    dataFieldName: 'b12',
    about: 'Исполнение КЦП прошлых лет',
    count: '19.4',
    max: 3,
    idUsl: 2,
  },
  {
    title: 'Б13',
    dataFieldName: 'b13',
    about: 'Доля целевого приема',
    count: '3.0',
    max: 4,
    idUsl: 2,
  },
  {
    title: 'Б21',
    dataFieldName: 'b21',
    about: 'Наличие ПОА',
    count: '1.8',
    max: 2,
    idUsl: 2,
  },
  {
    title: 'Б22',
    dataFieldName: 'b22',
    about: 'Соотношение (Маг+Асп)/БС',
    count: '9.0',
    max: 9,
    idUsl: 2,
  },
  {
    title: 'Б23',
    dataFieldName: 'b23',
    about: 'Соотношение (Маг+Асп+Орд)/БС',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 2,
  },
  {
    title: 'Б24',
    dataFieldName: 'b24',
    about: 'Соотношение (Маг+Асп+Асс)/БС',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 2,
  },
  {
    title: 'Б25',
    dataFieldName: 'b25',
    about: 'Процент сетевых образовательных программ',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 2,
  },
  {
    title: 'Б26',
    dataFieldName: 'b26',
    about: 'Процент сетевых обучающихся',
    count: 'Показатель не рассчитывается',
    max: 0,
    idUsl: 2,
  },
  {
    title: 'Б31',
    dataFieldName: 'b31',
    about: 'Трудоустройство выпускников',
    count: '18.7',
    max: 25,
    idUsl: 2,
  },
  {
    title: 'Б32',
    dataFieldName: 'b32',
    about: 'Сохранность контингента',
    count: '4.7',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'Б33',
    dataFieldName: 'b33',
    about: 'Доходы выпускников',
    count: '4.7',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'Б41',
    dataFieldName: 'b41',
    about: 'Публикации на 100 НПР',
    count: '0.4',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'Б42',
    dataFieldName: 'b42',
    about: 'Доходы от НИОКР на 1 НПР',
    count: '1.3',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'Б43',
    dataFieldName: 'b43',
    about: 'Доля иностранных студентов',
    count: '2.4',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'Б44',
    dataFieldName: 'b44',
    about: 'Доходы на 1 студента',
    count: '0.9',
    max: 5,
    idUsl: 2,
  },
  {
    title: 'M11',
    dataFieldName: 'm11',
    about: 'Заявления от выпусников др.организаций',
    idUsl: 3,
  },
  {
    title: 'M12',
    dataFieldName: 'm12',
    about: 'Поданные заявления / прием',
    idUsl: 3,
  },
  {
    title: 'M13',
    dataFieldName: 'm13',
    about: 'Доля платного приема',
    idUsl: 3,
  },
  {
    title: 'M14',
    dataFieldName: 'm14',
    about: 'Исполнение КЦП прошлых лет',
    idUsl: 3,
  },
  {
    title: 'M21',
    dataFieldName: 'm21',
    about: 'Наличие ПОА',
    idUsl: 3,
  },
  {
    title: 'M22',
    dataFieldName: 'm22',
    about: 'Соотношение Асп/Маг',
    idUsl: 3,
  },
  {
    title: 'M23',
    dataFieldName: 'm23',
    about: 'Соотношение ДПО/(БС+Маг)',
    idUsl: 3,
  },
  {
    title: 'M24',
    dataFieldName: 'm24',
    about: 'Доля целевого обучения',
    idUsl: 3,
  },
  {
    title: 'M25',
    dataFieldName: 'm25',
    about: 'Соотношение БС/М',
    idUsl: 3,
  },
  {
    title: 'M26',
    dataFieldName: 'm26',
    about: 'Процент сетевых образовательных программ',
    idUsl: 3,
  },
  {
    title: 'M27',
    dataFieldName: 'm27',
    about: 'Процент сетевых обучающихся',
    idUsl: 3,
  },
  {
    title: 'M31',
    dataFieldName: 'm31',
    about: 'Ср.доходы выпускников / СПМ',
    idUsl: 3,
  },
  {
    title: 'M32',
    dataFieldName: 'm32',
    about: 'Сохранность контингента',
    idUsl: 3,
  },
  {
    title: 'M41',
    dataFieldName: 'm41',
    about: 'Публикации на 100 НПР',
    idUsl: 3,
  },
  {
    title: 'M42',
    dataFieldName: 'm42',
    about: 'Доходы от НИОКР на 1 НПР',
    idUsl: 3,
  },
  {
    title: 'M43',
    dataFieldName: 'm43',
    about: 'Доля иностранных студентов',
    idUsl: 3,
  },
  {
    title: 'M44',
    dataFieldName: 'm44',
    about: 'Доходы на 1 студента',
    idUsl: 3,
  },
  {
    title: 'О11',
    dataFieldName: 'o11',
    about: 'Заявления от выпускников др.организаций',
    idUsl: 9,
  },
  {
    title: 'О12',
    dataFieldName: 'o12',
    about: 'Поданные заявления / прием',
    idUsl: 9,
  },
  {
    title: 'О13',
    dataFieldName: 'o13',
    about: 'Доля платного приема',
    idUsl: 9,
  },
  {
    title: 'О14',
    dataFieldName: 'o14',
    about: 'Исполнение КЦП прошлых лет',
    idUsl: 9,
  },
  {
    title: 'О21',
    dataFieldName: 'o21',
    about: 'Наличие ПОА',
    idUsl: 9,
  },
  {
    title: 'О22',
    dataFieldName: 'o22',
    about: 'Соотношение ДПО/(БС+Маг+Орд)',
    idUsl: 9,
  },
  {
    title: 'О23',
    dataFieldName: 'o23',
    about: 'Доля целевого обучения',
    idUsl: 9,
  },
  {
    title: 'О31',
    dataFieldName: 'o31',
    about: 'Ср.доходы выпускников / СПМ',
    idUsl: 9,
  },
  {
    title: 'О32',
    dataFieldName: 'o32',
    about: 'Ср.доходы выпускников / СПМ',
    idUsl: 9,
  },
  {
    title: 'О41',
    dataFieldName: 'o41',
    about: 'Публикации на 100 НПР',
    idUsl: 9,
  },
  {
    title: 'О42',
    dataFieldName: 'o42',
    about: 'Доходы от НИОКР на 1 НПР',
    idUsl: 9,
  },
  {
    title: 'О43',
    dataFieldName: 'o43',
    about: 'Доля иностранных студентов',
    idUsl: 9,
  },
  {
    title: 'О44',
    dataFieldName: 'o44',
    about: 'Доходы на обучающегося',
    idUsl: 9,
  },
  {
    title: 'K11',
    dataFieldName: 'k11',
    about: 'Заявления от выпускников др.организаций',
    idUsl: 12,
  },
  {
    title: 'K12',
    dataFieldName: 'k12',
    about: 'Поданные заявления / прием',
    idUsl: 12,
  },
  {
    title: 'K13',
    dataFieldName: 'k13',
    about: 'Доля платного приема',
    idUsl: 12,
  },
  {
    title: 'K14',
    dataFieldName: 'k14',
    about: 'Исполнение КЦП прошлых лет',
    idUsl: 12,
  },
  {
    title: 'K21',
    dataFieldName: 'k21',
    about: 'Наличие ПОА',
    idUsl: 12,
  },
  {
    title: 'K22',
    dataFieldName: 'k22',
    about: 'Соотношение ДПО/(БС+Маг+Асс)',
    idUsl: 12,
  },
  {
    title: 'K23',
    dataFieldName: 'k23',
    about: 'Доля целевого обучения',
    idUsl: 12,
  },
  {
    title: 'K31',
    dataFieldName: 'k31',
    about: 'Ср.доходы выпускников / СПМ',
    idUsl: 12,
  },
  {
    title: 'K32',
    dataFieldName: 'k32',
    about: 'Сохранность контингента',
    idUsl: 12,
  },
  {
    title: 'K41',
    dataFieldName: 'k41',
    about: 'Доля иностранных студентов',
    idUsl: 12,
  },
  {
    title: 'K42',
    dataFieldName: 'k42',
    about: 'Доходы на 1 обучающегося',
    idUsl: 12,
  },
  {
    title: 'A11',
    dataFieldName: 'a11',
    about: 'Исполнение КЦП прошлых лет',
    idUsl: 6,
  },
  {
    title: 'A21',
    dataFieldName: 'a21',
    about: 'Соотношение защиты/выпуск',
    idUsl: 6,
  },
  {
    title: 'A22',
    dataFieldName: 'a22',
    about: 'Соотношение защиты/прием',
    idUsl: 6,
  },
  {
    title: 'A23',
    dataFieldName: 'a23',
    about: 'Доля защит при целевом обучении',
    idUsl: 6,
  },
  {
    title: 'A31',
    dataFieldName: 'a31',
    about: 'Публикации на 100 НПР',
    idUsl: 6,
  },
  {
    title: 'A32',
    dataFieldName: 'a32',
    about: 'Доходы от НИОКР на 1 НПР',
    idUsl: 6,
  },
  {
    title: 'A33',
    dataFieldName: 'a33',
    about: 'Доходы от внебюджетных НИОКР на 1 НПР',
    idUsl: 6,
  },
  {
    title: 'A34',
    dataFieldName: 'a34',
    about: 'Доля иностранных аспирантов',
    idUsl: 6,
  },
  {
    title: 'A35',
    dataFieldName: 'a35',
    about: 'Доходы на 1 НПР',
    idUsl: 6,
  },
  {
    title: 'A36',
    dataFieldName: 'a36',
    about: 'Доходы на 1 НПР',
    idUsl: 6,
  },
]